/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainerType, ApiImportExternalErpItemsRequest } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ExternalErpContainerTypesController.
 */
export class ExternalErpContainerTypesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /external_erp/container_types:query
     */
    public getImportableContainerTypes(listRequest: ListRequest): Promise<Result<ListInfo<ApiContainerType>>> {
        return this.http.post<Result<ListInfo<ApiContainerType>>, ListRequest>('/external_erp/container_types:query', listRequest);
    }

    /**
     * Calls POST /external_erp/container_types:import
     */
    public importContainerTypes(request: ApiImportExternalErpItemsRequest): Promise<Result<ApiContainerType[]>> {
        return this.http.post<Result<ApiContainerType[]>, ApiImportExternalErpItemsRequest>('/external_erp/container_types:import', request);
    }
}
